import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EditPreference } from "../../../../Utils/AllPagesQuriesAndMutations";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { SuccessToast } from "../../ToastComponent/RectHotToast";
import { useModalContext } from "../../Reactportal/ModalContext";

export const InputFieldPreferences = ({
  formRef,
  formKey,
  prefConfig,
  show,
  setPrefShow,
  prevData,
  setFirstLoad,
  HanldeChangeonForm,
  allFieldsData,
  CloseFormFunctionForConfigForm,
  gettingDataofTax,
  forFormValues,
  ToGetDefaultValues,
}) => {
  // const formRef = useRef({});
  const [FormData, setFormData] = useState({});
  const [toggle, setToggle] = useState(show);
  const [EditSetUpPreference, { loading }] = useMutation(EditPreference);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const Modal_Key = "InputFieldPreferences";
  const { pushModal, popModal } = useModalContext();
  useEffect(() => {
    pushModal(Modal_Key);
  }, []);
  useEffect(() => {
    if (formKey) {
      updateValueForm(formRef, forFormValues);
    }
  }, [formKey]);

  const HandleFormValues = (values) => {
    console.log(values, "valuesvalues");
    setFormData((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const CloseFormFunction = async () => {
    console.log(Modal_Key, "modalStackmodalStackmodalStackmodalStackmodalStackmodalStackmodalStackmodalStack");
    popModal(Modal_Key);
    setToggle(false);
    setPrefShow(false);
    if (CloseFormFunctionForConfigForm) {
      CloseFormFunctionForConfigForm();
    }
  };

  let keyNotConvertToID = ["Default_From_City", "Default_To_City"];

  const SaveAndClose = () => {
    Object.keys(FormData).forEach((key) => {
      let master = FormDataFromRedux?.MasterData?.["Preference"]?.[key];
      console.log(master);
      if (
        master !== null &&
        master !== undefined &&
        master !== "" &&
        typeof master === "object" &&
        !keyNotConvertToID.includes(key)
      ) {
        FormData[key] = master?._id;
      }
    });
    console.log(formKey, FormData);
    EditSetUpPreference({
      variables: {
        userInput: {
          Form_Key: formKey,
          configurationData: FormData,
        },
      },
    }).then((res) => {
      HanldeChangeonForm(FormData);
      ToGetDefaultValues();
      CloseFormFunction();
      SuccessToast("Configuration Updated Successfuly");
    });
  };

  return (
    <>
      <Reactportal open={toggle} onClose={CloseFormFunction} TypeOfPortal={"Configure"}>
        <div className="formContainer">
          {prefConfig &&
            prefConfig.map((e) => {
              // console.log(e.fields);
              return (
                <>
                  <div className="">
                    <FormInputSectionComponent
                      TypeOfPortal={"Config"}
                      inputfields={e.fields}
                      onErrorsChange={() => {}}
                      onhandleFormikChange={HandleFormValues}
                      Type={"Bill_Details"}
                      formkey={"Preference"}
                      setFirstLoad={setFirstLoad}
                      formRef={formRef}
                    />
                  </div>
                </>
              );
            })}
        </div>

        <PortalFooter
          disabled={false}
          submitform={() => {
            SaveAndClose();
          }}
          submitType={""}
          Form_key={Modal_Key}
          SaveAndClose={() => {
            SaveAndClose();
          }}
          handleformclose={() => {
            CloseFormFunction();
          }}
          loadingState={loading}
        />
      </Reactportal>
    </>
  );
};
